import { useSelector } from "react-redux";
import { Navigate, Route, Routes } from "react-router-dom";

import { IAppState } from "store/app-state";

import {
  AccountSettingsPage,
  CategoriesPage,
  CollectionItemsPage,
  CollectionsPage,
  CrashPage,
  DMCAPage,
  EmbedPage,
  ExploreCreatorsPage,
  ExploreGifsPage,
  ExploreImagesPage,
  ExploreNichesPage,
  ExplorePage,
  FAQPage,
  FavouritesPage,
  FollowersPage,
  FollowingPage,
  GuidelinesPage,
  HomePage,
  LoginPage,
  ManagePage,
  MyNichesPage,
  NichePage,
  PrivacyPoicyPage,
  ProfileSettingsPage,
  Statement2257Page,
  TagPage,
  TermsPage,
  UnsubscribedPage,
  UploadPage,
  UserPage,
  VerifyPage,
  WatchPage,
} from "pages";
import WithAuthRequired from "./WithAuthRequired";
import { routes } from "routes";

const RoutesComponents = () => {
  const currentUserName = useSelector((state: IAppState) => state.user.currentUser.username);

  return (
    <Routes>
      <Route path={routes.crash()} element={<CrashPage />} />
      <Route path={routes.watch(":id")} element={<WatchPage />} />
      <Route path={routes.embed(":id")} element={<EmbedPage />} />
      <Route path={routes.home()} element={<HomePage />}>
        <Route path={":videoId"} element={<HomePage />} />
        <Route path={""} element={<HomePage />} />
      </Route>
      <Route path={routes.explore()} element={<ExplorePage />} />
      <Route path={routes.exploreCreators()} element={<ExploreCreatorsPage />} />
      <Route path={routes.exploreImages()} element={<ExploreImagesPage />} />
      <Route path={routes.exploreTop()} element={<ExploreGifsPage />} />
      <Route path={routes.niches()} element={<ExploreNichesPage />} />
      <Route path={routes.niches()} element={<ExploreNichesPage />} />
      <Route path={routes.myNiches()} element={<WithAuthRequired><MyNichesPage /></WithAuthRequired>} />
      <Route path={routes.favourites()} element={<WithAuthRequired><FavouritesPage /></WithAuthRequired>} />

      <Route path={routes.niche(":id")} element={<NichePage />} />
      <Route path={routes.user(":id")} element={<UserPage />} />
      <Route path={routes.userCollections(":userId")} element={<CollectionsPage />} />
      <Route path={routes.collection(":userId", ":id")} element={<CollectionItemsPage />} />
      <Route path={routes.following()} element={<WithAuthRequired><FollowingPage userName={currentUserName} /></WithAuthRequired>} />
      <Route path={routes.followers()} element={<WithAuthRequired><FollowersPage userName={currentUserName}/></WithAuthRequired>} />
      <Route path={routes.singleTag(":tag")} element={<TagPage />} />
      <Route path={routes.trendingTags()} element={<CategoriesPage />} />
      <Route path={routes.trendingTagsA(":letter")} element={<CategoriesPage />} />
      <Route path={routes.create()} element={<UploadPage />} />
      <Route path={routes.manageProfile()} element={<WithAuthRequired><ManagePage /></WithAuthRequired>} />
      <Route path={routes.accountSettings()} element={<WithAuthRequired><AccountSettingsPage /></WithAuthRequired>} />
      <Route path={routes.profileSettings()} element={<WithAuthRequired><ProfileSettingsPage /></WithAuthRequired>} />
      <Route path={routes.verify()} element={<WithAuthRequired><VerifyPage /></WithAuthRequired>} />
      <Route path={routes.unsubscribed()} element={<UnsubscribedPage />} />

      <Route path={routes.guidelines()} element={<GuidelinesPage />} />
      <Route path={routes.faq()} element={<FAQPage />} />
      <Route path={routes.terms()} element={<TermsPage />} />
      <Route path={routes.statement2257()} element={<Statement2257Page />} />
      <Route path={routes.dmca()} element={<DMCAPage />} />
      <Route path={routes.privacyPolicy()} element={<PrivacyPoicyPage />} />
      <Route path={routes.login()} element={<LoginPage />} />

      <Route path="*" element={<Navigate to={routes.home()} />} />
    </Routes>
  );
};

export default RoutesComponents;
